// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__qVHSf","pageLink":"Pagination_pageLink__-y4yl","active":"Pagination_active__T+Dy+"};